import { useState } from 'react';
import { isUndefined } from 'lodash-es';
import { usePrevious } from 'site-modules/shared/hooks/use-previous';

export const usePersistedData = data => {
  const [isLoading, setIsLoading] = useState(isUndefined(data));
  const [storedData, setStoredData] = useState(data);
  const prevData = usePrevious(data);

  if (prevData !== data) {
    if (isUndefined(data)) {
      setIsLoading(true);
    } else {
      setStoredData(data);
      setIsLoading(false);
    }
  }

  return [storedData, isLoading];
};
